import React, { Component } from 'react';
// import SvgIcon from 'material-ui/SvgIcon';
// import { ArrowRight } from '../../icons';
// import { BODY_TEXT_COLOR, NEGATIVE_COLOR, THIRD_COLOR } from '../../config/colors'
import { DropdownOpenedIcon , DropdownClosedIcon} from '../../icons'

import './style.css';

//  const ArrowDownIcon = (props) => (<SvgIcon {...props}>
//     <path d="M7 10l5 5 5-5z"/>
//     <path d="M0 0h24v24H0z" fill="none"/>
//     </SvgIcon>
// );
// const ArrowUpIcon = (props) => (<SvgIcon {...props}>
//     <path d="M7 14l5-5 5 5z"/>
//     <path d="M0 0h24v24H0z" fill="none"/>
//     </SvgIcon>
// );

const styles = {
  icons: {height:'40px', width:'40px', margin: '-10px -11px 0px'}
}
class ListItemNew extends Component {
  state = { expanded: false }
  handleClick = () => {
    this.setState({expanded: !this.state.expanded});
    // this.props.handleClick();
  }

  getTitle = (titleStyle) => {
    return this.props.titles.map((title, i) => <p key={i} style={titleStyle}>{title}</p>)
  }
  render() {
    const titleStyle = this.state.expanded ? { fontWeight: '700' } : {}
    return (
      <div onClick={this.handleClick}>
           <div className="list-item">
            {/*<p style={titleStyle}>{this.props.title}</p>*/}
            <div className="list-titles">{this.getTitle(titleStyle)}</div>
            <div style={{ marginLeft: 'auto', marginBottom: '0px'}}>
                { !this.state.expanded && <DropdownClosedIcon style={styles.icons} color="#616161"/> }
                { this.state.expanded && <DropdownOpenedIcon style={styles.icons} color="#616161"/> } 
              </div>
            </div>
           { this.state.expanded && 
             <div className="sub-items">
              {this.props.children}
             </div>
           }
      </div>
    );
  }
}

export default ListItemNew;



// WEBPACK FOOTER //
// ./src/components/ListItemNew/ListItemNew.jsx